import React from 'react';
import styled, { css } from 'styled-components';

import { LumpSumRepaymentTableImage } from 'assets/RepayYourLoansEarlyPage';
import { DebtFreeImage } from 'assets/RepayYourLoansEarlyPage';
import { Breadcrumbs } from 'components/Common';
import {
  ArticleHeading,
  ArticleImage,
  ArticleParagraph,
  ArticleSubHeading,
  ArticleTemplate,
} from 'components/Templates';
import { colorScale, minWidth } from 'themes';

import { GetDownToItSection } from './GetDownToItSection';

const HorizontalScrollImageWrapper = styled.div`
  overflow-x: scroll;
`;

const StyledArticleImage = styled(ArticleImage)`
  ${minWidth(
    'tablet',
    css`
      width: 100%;
    `
  )}
`;

export const RepayYourLoansEarlyPage = () => {
  return (
    <div>
      <Breadcrumbs backgroundColor={{ default: colorScale('primary', 10) }} />
      <ArticleTemplate
        heroIllustration={<DebtFreeImage />}
        heroIllustrationPosition="bottom"
        heading="Repay your loans earlier and live debt-free"
        readingTimeInMins={5}
        content={
          <>
            <ArticleParagraph>
              Whenever you have the extra money, paying off your loans is often a good choice. Some
              people do it to reduce the total interest payable, while others do it to reduce their
              stress or worry.
            </ArticleParagraph>
            <ArticleParagraph>
              You can prepay your loans by increasing your monthly payment, or by making lump sum
              repayments.
            </ArticleParagraph>
            <ArticleParagraph>
              But before you do so, ensure that you set aside at least 3-6 months of emergency
              funds. With a buffer, you won't have to take up more loans should you need a large sum
              of money unexpectedly.
            </ArticleParagraph>
            <ArticleHeading>Increase your monthly payment</ArticleHeading>
            <ArticleParagraph>
              You can consider increasing your monthly instalment amount when your pay increases to
              shorten the loan repayment period. The key is to find the balance between saving on
              interest and easing your monthly cashflow.
            </ArticleParagraph>
            <ArticleHeading>Make lump sum repayments</ArticleHeading>
            <ArticleParagraph>
              If you have some cash coming your way, you can use it to make a lump sum repayment on
              your loans. Your annual bonuses can go a long way in reducing your loan repayment
              period and helping you save on interest payable in the long run.
            </ArticleParagraph>
            <ArticleSubHeading>For example:</ArticleSubHeading>
            <ArticleParagraph>
              You have an outstanding HDB home loan of $300,000 over 20 years, and the loan’s
              interest rate is at 2.6%.{' '}
            </ArticleParagraph>
            <ArticleParagraph>
              You are considering making a $25,000 lump sum repayment and have 2 options to
              restructure your loan.
            </ArticleParagraph>
            <HorizontalScrollImageWrapper>
              <StyledArticleImage image={<LumpSumRepaymentTableImage />} />
            </HorizontalScrollImageWrapper>
          </>
        }
        callToActionSection={GetDownToItSection}
      />
    </div>
  );
};
